import { render, staticRenderFns } from "./ConfirmUser.vue?vue&type=template&id=8f61b9d4&"
import script from "./ConfirmUser.vue?vue&type=script&lang=js&"
export * from "./ConfirmUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports